import { BaseOption } from './base-option';

export class StatisticalMethod extends BaseOption { }
